import toast from "react-hot-toast";
import {BaseClient} from "../../Api/HttpClient";

export const createCustomerSlice = (set, get) => ({
    customers: [],
    customerMetaData: {},
    customerDetail: {},

    freelancersWorkedWith: [],
    freelancersWorkedWithMetaData: {},

    getAllCustomers: async (search = null, currentPage = null, extraParams = {}) => {
        let params = {}
        if(search) {
            params = {search: search}
        }
        if(currentPage) {
            params = {...params, page: currentPage}
        }
        params = {...params, ...extraParams}

        await BaseClient().get('/customers?' + new URLSearchParams(params).toString())
            .then(response => {
                if (response.status === 200) {
                    if(response.data.hasOwnProperty('meta')) {
                        set({customers: response.data?.data})
                        set({customerMetaData: response.data?.meta})
                    } else {
                        set({customers: response.data})
                    }
                } else {
                    toast.error(response.data);
                }
            })
    },
    getCustomerDetail: async (id) => {
        await BaseClient().get(`/customers/${id}`)
            .then(response => {
                if (response.status === 200) {
                    set({customerDetail: response.data})
                } else {
                    toast.error(response.data);
                }
            })
    },
    createCustomer: async (data) => {
        await BaseClient().post('/customers', data)
            .then(response => {
                if (response.status === 200) {
                    return response.data
                } else {
                    toast.error(response.data);
                }
            })
    },
    updateCustomer: async (id, data) => {
        await BaseClient().post(`/customers/${id}`, data)
            .then(response => {
                if (response.status === 200) {
                    set({customerDetail: response.data})
                } else {
                    toast.error(response.data);
                }
            })
    },
    deleteCustomer: async (id) => {
        await BaseClient().delete(`/customers/${id}`)
            .then(response => {
                if (response.status === 200) {
                    return response.data
                } else {
                    toast.error(response.data);
                }
            })
    },
    getFreelancersWhereWorkedWith: async (id, page = 1, branchId = null, search = null) => {
        let searchParams = new URLSearchParams();
        if (branchId) {
            searchParams.append('branch_id', branchId);
        }
        if (search) {
            searchParams.append('search', search);
        }
        searchParams.append('page', page);


        await BaseClient().get(`/customers/${id}/freelancers-worked-with-history?${searchParams.toString()}`)
            .then(response => {
                if (response.status === 200) {
                    set({freelancersWorkedWith: response.data?.data})
                    set({freelancersWorkedWithMetaData: response.data?.meta})
                } else {
                    toast.error(response.data);
                }
            })
    },

    addFreelancerToBlacklist: async (freelancerId, branchId = null) => {
        const params = new URLSearchParams({freelancer_id: freelancerId});
        if(branchId !== null) {
            params.append('branch_id', branchId);
        }

        await BaseClient().get(`/blacklist/freelancers?${params}`)
            .then(response => {
                if (response.status === 200) {
                    return true;
                } else {
                    toast.error(response.data);
                }
            })
    },

    removeFreelancerToBlacklist: async (freelancerId, branchId = null) => {
        const params = new URLSearchParams({freelancer_id: freelancerId});
        if(branchId !== null) {
            params.append('branch_id', branchId);
        }

        await BaseClient().get(`/blacklist/freelancers/remove?${params}`)
            .then(response => {
                if (response.status === 200) {
                    return true;
                } else {
                    toast.error(response.data);
                }
            })
    }
})